import { ElementType, Suspense, lazy, useEffect, useState } from 'react'
import { Navigate, RouteObject, useRoutes } from 'react-router-dom'
import AmeSpin from './components/AmeSpin/AmeSpin'
import { PAGE_LINKS } from './helpers/commonConsts'
import { Spin } from 'antd'
import { adminService } from './services/adminService'

const Loadable = (Component: ElementType) => (props: any) => (
  <Suspense fallback={<AmeSpin fullscreen={true} />}>
    <Component {...props} />
  </Suspense>
)

const AdminAuth = (p: { children: React.ReactNode }) => {
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    adminService
      .getUserInfo()
      .then(() => {
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }, [])

  if (loading) {
    return (
      <div
        style={{
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin spinning={loading} />
      </div>
    )
  }

  return adminService.userData ? p.children : <Navigate to={PAGE_LINKS.adminLogin} />
}

const HomePage = Loadable(lazy(() => import('./pages/HomePage/HomePage')))
const AdminLoginPage = Loadable(lazy(() => import('./pages/admin/LoginPage/LoginPage')))
const AdminLayout = Loadable(lazy(() => import('./pages/admin/AdminPage/AdminLayout')))
const GiftVipPage = Loadable(lazy(() => import('./pages/admin/AdminPage/pages/GiftVipPage')))
const CancelVipPage = Loadable(lazy(() => import('./pages/admin/AdminPage/pages/CancelVipPage')))
const SaleSlugPage = Loadable(lazy(() => import('./pages/admin/AdminPage/pages/SaleSlugPage')))

const routes: RouteObject[] = [
  {
    path: PAGE_LINKS.home,
    element: <HomePage />,
  },
  {
    path: PAGE_LINKS.adminLogin,
    element: <AdminLoginPage />,
  },
  {
    path: PAGE_LINKS.admin,
    element: (
      <AdminAuth>
        <AdminLayout />
      </AdminAuth>
    ),
    children: [
      {
        index: true,
        element: <GiftVipPage />,
      },
      {
        path: PAGE_LINKS.cancelVip,
        element: <CancelVipPage />,
      },
      {
        path: PAGE_LINKS.saleSlug,
        element: <SaleSlugPage />,
      },

      {
        path: '*',
        element: <Navigate to={PAGE_LINKS.admin} replace />,
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to={PAGE_LINKS.home} replace />,
  },
]

export const Router = () => {
  return useRoutes(routes)
}
